import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { parseRun } from '../../shared/utils/runTimeline';
import Timeline from 'react-calendar-timeline';
import { Alert } from 'react-bootstrap';
import RunStopsModal from '../RunStopsDetailModal/RunStopsModal';

const PREVIOUS_RUN_GROUP = 1;
const PLANNED_RUN_GROUP = 2;
const NEXT_RUN_GROUP = 3;

class ManifestTimeline extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showRunStopsModal: false,
            selectedRun: '',
        };
    }

    onItemSelect = (item, e) => {
        const run =
            e.currentTarget.dataset && e.currentTarget.dataset.run
                ? JSON.parse(e.currentTarget.dataset.run)
                : null;
        if (run) {
            this.setState({
                showRunStopsModal: true,
                selectedRun: run,
            });
        }
    };

    onClose = () => {
        this.setState({
            showRunStopsModal: false,
            selectedRun: '',
        });
    };

    noRunsGiven = (previousRun, plannedRun, nextRun) => {
        return !previousRun && !plannedRun && !nextRun;
    };

    getEarliestStartTime(items) {
        return moment.min(items.map(i => moment(i.start_time))).startOf('day');
    }

    getLatestEndTime(items) {
        return moment.max(items.map(i => moment(i.end_time))).endOf('day');
    }

    render() {
        const { plannedRun = null, nextRun = null, previousRun = null } = this.props;
        const { showRunStopsModal, selectedRun } = this.state;
        const groups = [{ id: PLANNED_RUN_GROUP, title: 'Planned run' }];

        if (!!previousRun && previousRun.length > 0) {
            // Add it before Planned run
            groups.splice(0, 0, {
                id: PREVIOUS_RUN_GROUP,
                title: 'Previous run',
            });
        }

        if (!!nextRun && nextRun.length > 0) {
            // Add it after Planned run
            groups.push({ id: NEXT_RUN_GROUP, title: 'Next run' });
        }

        const items = [];
        if (!!previousRun && previousRun.length > 0) {
            previousRun.forEach(run => {
                const timeblocks = parseRun(run, PREVIOUS_RUN_GROUP);
                timeblocks.forEach(timeblock => items.push(timeblock));
            });
        }

        if (!!plannedRun && plannedRun.length > 0) {
            plannedRun.forEach(run => {
                const timeblocks = parseRun(run, PLANNED_RUN_GROUP);
                timeblocks.forEach(timeblock => items.push(timeblock));
            });
        }

        if (!!nextRun && nextRun.length > 0) {
            nextRun.forEach(run => {
                const timeblocks = parseRun(run, NEXT_RUN_GROUP);
                timeblocks.forEach(timeblock => items.push(timeblock));
            });
        }

        if (this.noRunsGiven(previousRun, plannedRun, nextRun)) {
            return (
                <Alert bsStyle="info">
                    Manifest timeline unavailable: no run data for this manifest / manifest group.
                </Alert>
            );
        }

        return (
            <div>
                <Timeline
                    groups={groups}
                    items={items}
                    lineHeight={50}
                    canMove={false}
                    canResize={false}
                    canChangeGroup={false}
                    stackItems={true}
                    onItemSelect={this.onItemSelect}
                    defaultTimeStart={
                        items && items.length > 0
                            ? this.getEarliestStartTime(items)
                            : moment()
                                  .subtract(3, 'day')
                                  .startOf('day')
                    }
                    defaultTimeEnd={
                        items && items.length > 0
                            ? this.getLatestEndTime(items)
                            : moment()
                                  .add(4, 'day')
                                  .startOf('day')
                    }
                />
                <RunStopsModal
                    showModal={showRunStopsModal}
                    runInfo={selectedRun}
                    runId={selectedRun && selectedRun.runId}
                    onClose={this.onClose}
                />
            </div>
        );
    }
}

ManifestTimeline.propTypes = {
    plannedRun: PropTypes.array,
    nextRun: PropTypes.array,
    previousRun: PropTypes.array,
};
ManifestTimeline.defaultProps = {};

ManifestTimeline.contextTypes = {
    router: PropTypes.object.isRequired,
};

export default ManifestTimeline;
